(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-saloon-hero-slider]').forEach((gallery) => {
      if (gallery.dataset.ready === 'true') return;
      gallery.dataset.ready = 'true';
      const track = gallery.querySelector('[data-saloon-hero-track]');
      const slides = [...gallery.querySelectorAll('[data-saloon-hero-slide]')];
      const dots = [...gallery.querySelectorAll('[data-saloon-hero-dot]')];
      const count = gallery.querySelector('[data-saloon-hero-count]');
      if (!track || slides.length < 2) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let timer;
      let hovering = false;
      let pointerStart;
      let moved = false;
      let scrollFrame;
      const paint = () => {
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
        slides.forEach((slide, slideIndex) => {
          const link = slide.querySelector('a');
          if (link) link.tabIndex = slideIndex === index ? 0 : -1;
        });
      };
      const go = (nextIndex, smooth = true) => {
        index = (nextIndex + slides.length) % slides.length;
        track.scrollTo({left: slides[index].offsetLeft - track.offsetLeft, behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant'});
        paint();
      };
      const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
      const start = () => {
        stop();
        if (reducedMotion.matches || hovering || document.hidden) return;
        timer = window.setInterval(() => go(index + 1), 12000);
      };
      gallery.querySelector('[data-saloon-hero-prev]')?.addEventListener('click', () => { go(index - 1); start(); });
      gallery.querySelector('[data-saloon-hero-next]')?.addEventListener('click', () => { go(index + 1); start(); });
      dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => { go(dotIndex); start(); }));
      track.addEventListener('scroll', () => {
        if (pointerStart) return;
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const nextIndex = Math.round(track.scrollLeft / track.clientWidth);
          if (nextIndex >= 0 && nextIndex < slides.length && nextIndex !== index) { index = nextIndex; paint(); }
        });
      }, {passive: true});
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerStart = {x: event.clientX, scrollLeft: track.scrollLeft};
        moved = false;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', (event) => {
        if (!pointerStart) return;
        const distance = event.clientX - pointerStart.x;
        if (Math.abs(distance) > 5) moved = true;
        if (moved) track.scrollLeft = pointerStart.scrollLeft - distance;
      });
      const endDrag = () => {
        if (!pointerStart) return;
        pointerStart = undefined;
        track.classList.remove('is-dragging');
        if (moved) go(Math.round(track.scrollLeft / track.clientWidth));
        start();
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      track.addEventListener('click', (event) => { if (moved) { event.preventDefault(); moved = false; } }, true);
      gallery.addEventListener('mouseenter', () => { hovering = true; stop(); });
      gallery.addEventListener('mouseleave', () => { hovering = false; start(); });
      gallery.addEventListener('focusin', stop);
      gallery.addEventListener('focusout', () => { if (!gallery.contains(document.activeElement)) start(); });
      document.addEventListener('visibilitychange', start);
      reducedMotion.addEventListener?.('change', start);
      paint();
      start();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
